// src/pages/TermsConditions.tsx
import { useTranslation } from 'react-i18next';
import { useCms } from '../../hooks/useCms';

export function TermsConditions() {
  const { t } = useTranslation('auth');
  const { get } = useCms('terms');

  // Get sections array from translations
  const fallbackSections = t('termsCondition.sections', { returnObjects: true }) as Array<{ title: string; content: string }>;
  const cmsSections = get('content.body', '').split('\n').map((line: string) => line.split('|').map(part => part.trim())).filter((parts: string[]) => parts.length >= 2 && parts[0] && parts[1]).map(([title, ...content]: string[]) => ({ title, content: content.join(' | ') }));
  const structuredSections = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(number => ({ title: get(`content.section${number}Title`, ''), content: get(`content.section${number}Content`, '') })).filter(section => section.title && section.content);
  const availableSections = structuredSections.length ? structuredSections : cmsSections;
  const intro = availableSections[0]?.title.toLowerCase() === 'introduction' ? availableSections[0].content : t('termsCondition.intro');
  const sections = availableSections.length ? (availableSections[0]?.title.toLowerCase() === 'introduction' ? availableSections.slice(1) : availableSections) : fallbackSections;

  return (
    <div className="bg-white min-h-screen">
      <div className="bg-gradient-to-br from-[#2D323A] to-[#1E2229] text-white py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl text-white mb-3">{get('content.title', t('termsCondition.title'))}</h1>
          <p className="text-white/70">{get('content.lastUpdated', t('termsCondition.lastUpdated'))}</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 py-10">
        <div className="bg-[#F59E0B]/5 border border-[#F59E0B]/20 rounded-2xl p-5 mb-8">
          <p className="text-[#2D323A] text-sm leading-relaxed">
            {intro}
          </p>
        </div>
        <div className="space-y-8">
          {sections.map((s, i) => (
            <div key={i}>
              <h2 className="text-xl text-[#2D323A] mb-3">{s.title}</h2>
              <p className="text-[#717182] leading-relaxed">{s.content}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
